export const BASE_PATH = '/fees-management/catalog-v2';
